export * from './admin.service';
import { AdminService } from './admin.service';
export * from './adminDashboard.service';
import { AdminDashboardService } from './adminDashboard.service';
export * from './appActivityReports.service';
import { AppActivityReportsService } from './appActivityReports.service';
export * from './connectivityReports.service';
import { ConnectivityReportsService } from './connectivityReports.service';
export * from './internal.service';
import { InternalService } from './internal.service';
export * from './keystrokeReports.service';
import { KeystrokeReportsService } from './keystrokeReports.service';
export * from './screenshotReports.service';
import { ScreenshotReportsService } from './screenshotReports.service';
export * from './timeSheetReports.service';
import { TimeSheetReportsService } from './timeSheetReports.service';
export * from './webActivityReports.service';
import { WebActivityReportsService } from './webActivityReports.service';
export const APIS = [AdminService, AdminDashboardService, AppActivityReportsService, ConnectivityReportsService, InternalService, KeystrokeReportsService, ScreenshotReportsService, TimeSheetReportsService, WebActivityReportsService];
